import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 32 32"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", { d: "M32 16 16 32 0 16l2.1-2.1 12.4 12.4V0h3v26.3l12.4-12.4z" }, null, -1)
  ]));
}
const ArrowDown = { render };
export {
  ArrowDown as default,
  render
};
//# sourceMappingURL=ArrowDown.svg.js.map
